import styled from '@emotion/styled'
import React from 'react'
import DonutChart from 'react-svg-donut-chart'
import { TextBold, Text } from 'src/components/Typography'
import { isMobileOnly } from 'react-device-detect'
import { css } from '@emotion/core'

const DonutContainer = styled.div`
  width: 140px;
  text-align: center;
  position: relative;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    flex-basis: 50%;
    max-width: 40%;
    margin-bottom: 40px;
  }
`

const DonutScore = styled(Text)`
  position: absolute;
  top: 48px;
  left: 50%;
  transform: translateX(-50%);

  ${isMobileOnly &&
  css`
    @media (orientation: landscape) {
      top: 26%;
      font-size: 10px;
    }

    @media screen and (max-width: 800px) {
      top: 21%;
    }
  `}

  @media screen and (max-width: 600px) {
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    color: #aeaeae;
    margin-top: 5%;
    top: calc(50% - 14px);
  }
`
const DonutBoldScore = styled.span`
  font-weight: 500;
  font-size: 23px;
  line-height: 16px;
  color: #3b424f;
  float: left;
  padding-right: 3px;
`

const DonutTextBold = styled(TextBold)`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #000000;
`

export default function ChartComponent({
  title,
  value,
  maxValue,
  color,
  isPercent,
}: {
  title: string
  value: number
  maxValue: number
  color: string
  isPercent?: boolean
}) {
  const valuePct = (value / maxValue) * 100
  return (
    <DonutContainer>
      <DonutChart
        data={[
          { value: valuePct, stroke: color, strokeWidth: 2.5 },
          { value: 100 - valuePct, stroke: '#E1E3EA', strokeWidth: 2.5 },
        ]}
        style={{
          transform: 'rotate(90deg) scale(-1,1)',
          width: 110,
        }}
      />
      <DonutTextBold>{title}</DonutTextBold>
      <DonutScore>
        {!isPercent && (
          <>
            <DonutBoldScore>{value}</DonutBoldScore> / 5
          </>
        )}
        {isPercent && (
          <>
            <DonutBoldScore>{value}%</DonutBoldScore>
          </>
        )}
      </DonutScore>
    </DonutContainer>
  )
}

ChartComponent.defaultProps = {
  isPercent: false,
}
